import { ColumnDef } from "@tanstack/react-table";

import SmsSimulatorPersonasTableActionsMenu from "containers/sms-simulator/sms-simulator-personas/components/sms-simulator-personas-table-actions-menu";

import { formatDateTime } from "utilities/date";

import { PersonasTableActionsProps } from "containers/sms-simulator/sms-simulator-personas/sms-simulator-personas.types";
import { SmsSimulatorPersonaAttributes } from "containers/sms-simulator/sms-simulator.types";

const headerStyles = "text-gray-600 font-bold text-sm leading-5 px-4";

export const createSmsSimulatorPersonasColumns = ({
  onEdit,
  onDelete,
}: PersonasTableActionsProps): ColumnDef<SmsSimulatorPersonaAttributes>[] => [
  {
    id: "name",
    header: "Persona",
    accessorKey: "name",
    enableSorting: true,
    cell: ({ row }) => <span className="text-gray-600 text-sm">{row.original.name}</span>,
    size: 100,
    meta: {
      headerClassName: `${headerStyles}`,
      className: "py-1 ",
    },
  },
  {
    id: "Grade",
    header: "Grade",
    accessorKey: "grade",
    enableSorting: true,
    cell: ({ row }) => {
      return <span className="text-gray-600 text-sm">{row.original.grade}</span>;
    },
    size: 70,
    meta: {
      headerClassName: `${headerStyles}`,
      className: "py-1",
    },
  },
  {
    id: "profileType",
    header: "Profile Type",
    accessorKey: "profileType",
    enableSorting: true,
    cell: ({ row }) => {
      return <span className="text-gray-600 text-sm">{row.original.profileType}</span>;
    },
    size: 100,
    meta: {
      headerClassName: `${headerStyles}`,
      className: "py-1",
    },
  },
  {
    id: "interests",
    header: "Interests",
    accessorKey: "interests",
    enableSorting: true,
    cell: ({ row }) => {
      return (
        <span className="text-gray-600 text-sm whitespace-pre-line">{row.original.interests}</span>
      );
    },
    size: 400,
    meta: {
      headerClassName: `${headerStyles}`,
      className: "py-1 ",
    },
  },
  {
    id: "lastModifiedDate",
    header: "Last updated",
    accessorKey: "lastModifiedDate",
    enableSorting: true,
    cell: ({ row }) => (
      <div className="text-gray-600 text-sm">{formatDateTime(row.original.lastModifiedDate)}</div>
    ),
    size: 150,
    meta: {
      headerClassName: `${headerStyles}`,
      className: "py-1",
    },
  },
  {
    id: "action",
    header: "Action",
    enableSorting: false,
    cell: ({ row }) => (
      <SmsSimulatorPersonasTableActionsMenu
        item={{ itemName: row.original.name, itemId: row.original.id }}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    ),
    size: 80,
    meta: {
      headerClassName: headerStyles,
      className: "py-1",
      isHeaderCentered: true,
    },
  },
];
